/*Javascript*/
"use strict";
/*
To do :
 - recherche en cliquant sur les noms et genre(page film)
 - recherche par genre et personnes 

*/





/*popular*/


fetch("https://garith.be/b2/tmdb/api/discover/movie&sort_by=popularity.desc&language=fr")
 .then(response => response.json())
 .then(popular => {

 	var data = popular.results
 	var mainlist__titleContent = "Les plus populaires";

 	/*Banner*/
 	let banner__title = document.querySelector('.banner__title')
 	banner__title.innerHTML = data[0].title;
 	let banner__link = document.querySelector('.banner__link')
 	banner__link.setAttribute("movie-id", data[0].id)
 	banner__link.setAttribute('href', "#"+data[0].title)
 	banner__link.style.backgroundImage='url(https://image.tmdb.org/t/p/original'+data[0].backdrop_path+')';

 	let banner__btn = document.querySelector(".banner__btn");
 	banner__btn.classList.add('btn');
 	searchInMyList(data[0], banner__btn)

 	banner__link.addEventListener('click', function(e){
 		chosemovie(e)
 	})
 	let banner__more = document.querySelector('.banner__more');
 	banner__more.setAttribute("movie-id", data[0].id)
 	banner__more.addEventListener('click', function(e){
 		chosemovie(e)
 	})

 	/*list*/
 	let url = "https://garith.be/b2/tmdb/api/discover/movie";
 	let total_pages = popular.total_pages;
 	discover(data, mainlist__titleContent, url, total_pages)

 })

/*Release this week*/

fetch("https://garith.be/b2/tmdb/api/movie/now_playing&language=fr")
 .then(response=>response.json())
 .then(theatre=>{
 	let data = theatre.results;
 	let mainlist__titleContent = "Actuellement au cinéma";

 	let url = "https://garith.be/b2/tmdb/api/movie/now_playing";
 	let total_pages = theatre.total_pages;
 	discover(data, mainlist__titleContent, url, total_pages)
 })

/*Genre*/

fetch("https://garith.be/b2/tmdb/api/genre/movie/list&language=fr")
 .then(response=>response.json())
 .then(genre=>{
 	genre.genres.forEach(genre=>{
 		let url = "https://garith.be/b2/tmdb/api/discover/movie&with_genres="+genre.id;
 		fetch(url+"&sort_by=popularity.desc&language=fr")
		 .then(response => response.json())
		 .then(movieGenre => {
		 	let data = movieGenre.results;
		 	let mainlist__titleContent = genre.name;
		 	let total_pages = movieGenre.total_pages;
		 	discover(data, mainlist__titleContent, url, total_pages)
		 })
 	})
 })



/*Create new list discover*/

function discover(data, mainlist__titleContent, url, total_pages){
		

	let mainlist = document.querySelector('.mainlist');
	let mainlist__el = document.createElement('li');
	mainlist__el.classList.add('mainlist__el');
	let mainlist__title = document.createElement('h2');
	mainlist__title.classList.add('mainlist__title','title');
	let mainlist__titleLink = document.createElement('a');
	let mainlist__list = document.createElement('ul');
	mainlist__list.classList.add('mainlist__list');

	mainlist.appendChild(mainlist__el);
	mainlist__el.appendChild(mainlist__title);
	mainlist__titleLink.innerHTML= mainlist__titleContent;
	mainlist__titleLink.setAttribute('data-url',url);
	mainlist__titleLink.setAttribute('href',"#"+mainlist__titleContent);
	mainlist__title.appendChild(mainlist__titleLink)
	mainlist__el.appendChild(mainlist__list);
	mainlist__list.setAttribute('listName', mainlist__titleContent)
		

	/*Title link*/
	mainlist__titleLink.addEventListener('click', function(e){
		e.preventDefault()
		pagesearch(url, total_pages, mainlist__titleContent)
	})


	data.forEach(movieData => {

		 movieContent(mainlist__list, movieData)
 	})
 	for (var i = 1; i >= 0; i--) {
		let mainlist__btn = document.createElement('button');
		mainlist__btn.classList.add('mainlist__btn');

		let counter = 0;
		mainlist__list.setAttribute('counter', counter)

		if(i==0){
			mainlist__btn.innerHTML=">"
			mainlist__btn.classList.add('mainlist__btn--right');
			mainlist__btn.setAttribute('listName', mainlist__titleContent)
			mainlist__btn.addEventListener('click', function(e){
				let listName = e.currentTarget.getAttribute('listName')
				document.querySelectorAll('.mainlist__list').forEach((e)=>{
					
					if(e.getAttribute('listName')==listName){
						let translateWidth = e.parentNode.offsetWidth/2
						let translateWidth_max = 4075-e.parentNode.offsetWidth;
						counter = e.getAttribute('counter');
						counter++

						if(translateWidth*counter<translateWidth_max){
							e.style.transform = "translateX(-"+translateWidth*counter+"px)";
						}else if(e.style.transform=="translateX(-"+translateWidth_max+"px)"){
							e.style.transform = "translateX(0px)";
							counter = 0;
						}else{
							e.style.transform = "translateX(-"+translateWidth_max+"px)";
						}
						e.setAttribute('counter', counter)
					}
				})
			})


		}else{
			mainlist__btn.innerHTML="<"
			mainlist__btn.classList.add('mainlist__btn--left');
			mainlist__btn.setAttribute('listName', mainlist__titleContent)
			mainlist__btn.addEventListener('click', function(e){
				let listName = e.currentTarget.getAttribute('listName')
				document.querySelectorAll('.mainlist__list').forEach((e)=>{
					
					if(e.getAttribute('listName')==listName){
						let translateWidth_max = 4075-e.parentNode.offsetWidth
						let translateWidth = e.parentNode.offsetWidth/2
						let translateWidth_min = 0;
						counter = e.getAttribute('counter');
						counter--

						if(translateWidth*counter>translateWidth_min){
							e.style.transform = "translateX(-"+translateWidth*counter+"px)";
						}else if (counter == 0){
							e.style.transform = "translateX(-"+translateWidth_min+"px)";
						}else{
							e.style.transform = "translateX(-"+translateWidth_max+"px)";
							while(translateWidth*counter<translateWidth_max){
								counter++
							}
						}
						e.setAttribute('counter', counter)
					}
				})
			})

		}
		mainlist__el.appendChild(mainlist__btn);	
	}
}

/*Movie*/

function movieContent(list, movieData){
	let movie = document.createElement('li');
	movie.classList.add('movie');
	let btn = document.createElement('button');
	btn.classList.add('btn');
	let movie__link = document.createElement('a');
	movie__link.classList.add('movie__link');
	let movie__img = document.createElement('img');
	movie__img.classList.add('movie__img');
	let movie__contain = document.createElement('div');
	movie__contain.classList.add('movie__contain');
	let movie__title = document.createElement('h3');
	movie__title.classList.add('movie__title','title','title--small');

	list.appendChild(movie);
	movie.appendChild(movie__link);
	movie.appendChild(btn);
	movie__link.appendChild(movie__contain);
	movie__contain.style.height = movie__contain.offsetWidth*1.5+"px";
	movie__contain.appendChild(movie__img);
	movie__link.appendChild(movie__title);

	movie__link.setAttribute('movie-id', movieData.id);
	movie__link.setAttribute('href', "#"+movieData.title);

	movie__title.setAttribute('title', movieData.title)
	let movieTitle = movieData.title;
	if(movieTitle.length>16){
		movieTitle = movieTitle.slice(0,16)+"...";
	}
	movie__title.innerHTML=movieTitle;
	if(movie__title.offsetWidth > movie.offsetWidth-45){
		movie__title.style.width = movie.offsetWidth-50+"px";
	}
	if (movieData.poster_path) {
		movie__img.setAttribute('src', "https://image.tmdb.org/t/p/w300"+movieData.poster_path);
	}else{
		movie__img.setAttribute('src',"assets/images/poster.png")
	}
	movie__img.setAttribute('alt', movieData.title);

	searchInMyList(movieData, btn);

	movie__link.addEventListener('click', function(e){
		chosemovie(e)
	})
}


/*Nav*/

let nav__el__search = document.querySelector('.nav__el--search');
let movielist = document.querySelector('.movielist');

nav__el__search.addEventListener('click', function(e){
	e.preventDefault()
	document.body.setAttribute('data-page','search');
	movielist.innerHTML="";
	document.querySelector('.search__input').value = "";
	document.querySelector('.searchResult').innerHTML= "";

	let bluescreen = document.querySelector('.bluescreen');
	bluescreen.classList.add('bluescreen--trans');
	bluescreen.addEventListener('animationend', function(){
		bluescreen.classList.remove('bluescreen--trans')
	})
})


/*Search*/

let timeout = null
let search__input = document.querySelector('.search__input');

document.querySelector('.search').addEventListener('submit', function(e){
	e.preventDefault()
	functionSearch()
})
search__input.addEventListener('input', function(e){
	functionSearch()
})


function functionSearch(){
	clearTimeout(timeout)

	timeout = setTimeout(function(e) {
		let searchName = search__input.value;
		if(search__input.value == 0){

			let searchlist = document.querySelector('.searchlist');
			if(searchlist){
				searchlist.innerHTML="";
			}

		}else{
			let url = "https://garith.be/b2/tmdb/api/search/movie&query="+searchName;
			fetch(url)
			 .then(response=>response.json())
			 .then(search=>{
			 	let total_pages = search.total_pages;
			 	pagesearch(url, total_pages, searchName);
		 	})
		}

	}, 500);
}





/*pagesearch*/

function pagesearch(url, total_pages, searchName){
	
	document.body.setAttribute('data-page','search');
	let movielist = document.querySelector('.movielist');
	movielist.setAttribute('url', url)
	movielist.innerHTML="";
	document.querySelector('.searchResult').innerHTML = searchName;
	let counter_page = 1;
	movielist.style.minHeight = "0px";

	PageResults(url)
	document.addEventListener('scroll', scroll);


	function scroll(){
		if(url !== movielist.getAttribute('url')){
			return;
		}
		let searchlist_height = movielist.offsetHeight-100;

		let document_scroll = document.documentElement.scrollTop+window.innerHeight;
		if(searchlist_height<document_scroll){
			
			if(counter_page<=10&&counter_page<=total_pages){
				counter_page++
				searchlist_height = searchlist_height+200
				movielist.style.minHeight = searchlist_height+"px";

				PageResults(url)
			}
		}
	}

	function PageResults(url){
		fetch(url+"&page="+counter_page+"&language=fr&sort_by=popularity.desc")
		 .then(response=>response.json())
		 .then(page=>{
		 	page.results.forEach((movie)=>{
		 		movieContent(movielist, movie)
		 	})
		 	
		 })
	}
}

/*search in myList*/

function searchInMyList(movie, button){

	let idTab_json = JSON.parse(localStorage.getItem('idTab'))
	button.setAttribute('inlist', "false")
	if(button.classList.contains('pagemovie__btn')){
		button.innerHTML='Ajouter à ma liste';
	}else{
		button.innerHTML='+';
		button.setAttribute('title','Ajouter à ma liste');
	}
	button.classList.add('btn--add')
	if(idTab_json!=null){

		idTab_json.forEach((i)=>{
			if(i==movie.id){
				if(button.classList.contains('pagemovie__btn')){
					button.innerHTML='Retirer de ma liste';
				}else{
					button.innerHTML='-';
					button.setAttribute('title','Retirer de ma liste');
				}
				button.classList.remove('btn--add')
				button.classList.add('btn--suppr')
				button.setAttribute('inlist', "true")
			}
		})
	}
	
	button.addEventListener('click', function(){
		let boolean = button.getAttribute('inlist')
		if(boolean=="true"){
			removeFromList(movie, button);
		}else{
			addToList(movie, button);
		}
	})
}


/*Chose movie*/
function chosemovie(e){

	let bluescreen = document.querySelector('.bluescreen');
	bluescreen.classList.add('bluescreen--trans');
	bluescreen.addEventListener('animationend', function(){
		bluescreen.classList.remove('bluescreen--trans')
	})

	let movie_id = e.currentTarget.getAttribute('movie-id')
	document.body.setAttribute('data-page','movie')

	fetch("https://garith.be/b2/tmdb/api/movie/"+movie_id+"&language=fr")
	 .then(response=>response.json())
	 .then(movie=>{
	 	document.querySelector('.headtitle__el--movie .title').innerHTML = movie.title;
	 	let pagemovie__img = document.querySelector('.pagemovie__img');
	 	if (movie.poster_path) {
 			pagemovie__img.setAttribute('src', "https://image.tmdb.org/t/p/w300"+movie.poster_path);
 		}else{
 			pagemovie__img.setAttribute('src',"assets/images/poster.png")
 		}
 		pagemovie__img.setAttribute('alt', movie.title);

 		let pagemovie__title = document.querySelector('.pagemovie__title').innerHTML = movie.title;
 		let pagemovie__year = document.querySelector('.pagemovie__year');
 		pagemovie__year.innerHTML= movie.release_date.slice(0,4);
 		let pagemovie__resume = document.querySelector('.pagemovie__resume').innerHTML = movie.overview;

 		let pagemovie__genre = document.querySelector('.pagemovie__genre');
 		pagemovie__genre.innerHTML = ""

 		let pagemovie__btn = document.querySelector('.pagemovie__btn');
 		searchInMyList(movie, pagemovie__btn)

 		movie.genres.forEach((genre)=>{
 			let pagemovie__genre__link = document.createElement('a');
 			pagemovie__genre__link.setAttribute('href', '#'+genre.name);
 			pagemovie__genre__link.setAttribute('genre-id', genre.id);
 			pagemovie__genre__link.innerHTML=genre.name
 			let pagemovie__el = document.createElement('li')
 			pagemovie__el.classList.add('pagemovie__el');
 			pagemovie__el.appendChild(pagemovie__genre__link)
 			pagemovie__genre.appendChild(pagemovie__el)

 			pagemovie__genre__link.addEventListener('click', function(e){
 				let url = "https://garith.be/b2/tmdb/api/discover/movie&with_genres="+genre.id;
 				let genreTitle = genre.name;
 				let total_pages = 11;
 				e.preventDefault()
				pagesearch(url, total_pages, genreTitle)
 			})
 		})
	 })

	fetch("https://garith.be/b2/tmdb/api/movie/"+movie_id+"/credits")
	 .then(response=>response.json())
	 .then(credits=>{
	 	let pagemovie__director = document.querySelector('.pagemovie__director');
	 	pagemovie__director.innerHTML=""
	 	credits.crew.forEach((i)=>{
	 		if (i.job=="Director"){
	 			let pagemovie__director__link = document.createElement('a');
	 			pagemovie__director__link.setAttribute('href', '#'+i.name);
	 			pagemovie__director__link.setAttribute('credits-id', i.id);
	 			pagemovie__director__link.innerHTML=i.name
	 			let pagemovie__el = document.createElement('li')
	 			pagemovie__el.classList.add('pagemovie__el');
 				pagemovie__el.appendChild(pagemovie__director__link)
 				pagemovie__director.appendChild(pagemovie__el)

 				pagemovie__director__link.addEventListener('click', function(e){
 					e.preventDefault()
	 				let url = "https://garith.be/b2/tmdb/api/discover/movie&with_crew="+i.id;
	 				let genreTitle = i.name;
	 				let total_pages = 11;
	 				fetch(url)
	 				 .then(response=>response.json())
	 				 .then(pagecrew=>{
	 				 	let total_pages = pagecrew.total_pages
	 				 	pagesearch(url, total_pages, genreTitle)
	 				 })
	 			})

	 		}
	 	})
	 	let pagemovie__actor = document.querySelector('.pagemovie__actor');
	 	pagemovie__actor.innerHTML=""
	 	
	 	for (var i = 0; i < 3; i++) {
	 		let pagemovie__actor__link = document.createElement('a');
 			pagemovie__actor__link.setAttribute('href', '#'+credits.cast[i].name);
 			pagemovie__actor__link.setAttribute('credits-id', credits.cast[i].id);
 			pagemovie__actor__link.innerHTML=credits.cast[i].name
 			let pagemovie__el = document.createElement('li')
 			pagemovie__el.classList.add('pagemovie__el');
 			pagemovie__el.appendChild(pagemovie__actor__link)
 			pagemovie__actor.appendChild(pagemovie__el);
 			console.log(credits.cast[i].id)
 			let cast_id = credits.cast[i].id;
 			let cast_name = credits.cast[i].name;

 			pagemovie__actor__link.addEventListener('click', function(e){
 					e.preventDefault()
	 				let url = "https://garith.be/b2/tmdb/api/discover/movie&with_cast="+cast_id;
	 				console.log(url)
	 				let genreTitle = cast_name;
	 				let total_pages = 11;
	 				fetch(url)
	 				 .then(response=>response.json())
	 				 .then(pagecast=>{
	 				 	let total_pages = pagecast.total_pages
	 				 	pagesearch(url, total_pages, genreTitle)
	 				 })
	 			})
	 	}
	 })
}


/*Mylist*/


/*addToList*/

function addToList(movie, button){

	let idTab_json = JSON.parse(localStorage.getItem('idTab'))

	if(idTab_json == null){
		idTab_json=[movie.id]

	}else{
		let boolean = true;
		
		idTab_json.forEach((i)=>{
			if(movie.id ==i){
				boolean = false
			}
		})
		if(boolean==true){
			idTab_json.push(movie.id)
		}
	}

	if(button.classList.contains('pagemovie__btn')){
		button.innerHTML='Retirer de ma liste';
	}else{
		button.innerHTML='-';
		button.setAttribute('title','Retirer de ma liste');
	}
	button.classList.remove('btn--add')
	button.classList.add('btn--suppr')
	if(button.parentNode.firstChild.firstChild){
		button.parentNode.firstChild.firstChild.classList.remove('movie__suppr');
	}
	button.setAttribute('inlist', "true")

	let idTab = JSON.stringify(idTab_json)
	localStorage.setItem('idTab', idTab)
	/*localStorage.removeItem('idTab')*/
}

/*removeFromList*/

function removeFromList(movie, button){
	let idTab_json = JSON.parse(localStorage.getItem('idTab'))

	idTab_json.splice(idTab_json.indexOf(movie.id), 1)
	button.setAttribute('inlist', "false");
	if(button.classList.contains('pagemovie__btn')){
		button.innerHTML='Ajouter à ma liste';
	}else{
		button.innerHTML='+';
		button.setAttribute('title','Ajouter à ma liste');
	}
	button.classList.add('btn--add')
	button.classList.remove('btn--suppr');
	if(button.parentNode.firstChild.firstChild){
		button.parentNode.firstChild.firstChild.classList.add('movie__suppr');
	}

	let idTab = JSON.stringify(idTab_json)
	localStorage.setItem('idTab', idTab)
	/*localStorage.removeItem('idTab')*/

}

/*myList*/

document.querySelector('.nav__el--list').addEventListener('click', function(e){

	let bluescreen = document.querySelector('.bluescreen');
	bluescreen.classList.add('bluescreen--trans');
	bluescreen.addEventListener('animationend', function(){
		bluescreen.classList.remove('bluescreen--trans')
	})

	document.body.setAttribute('data-page','list');
	let idTab_json = JSON.parse(localStorage.getItem('idTab'))
	let movielist=document.querySelector('.movielist');
	movielist.setAttribute('url', "");
	movielist.innerHTML="";
	movielist.style.minHeight = "0px";
	if(idTab_json==null){
		document.querySelector('.nolist').innerHTML = "Vous n'avez pas encore ajouter de films à votre liste"
	}else{
		idTab_json.forEach((movie_id)=>{
			fetch("https://garith.be/b2/tmdb/api/movie/"+movie_id+"&language=fr")
			 .then(response=>response.json())
			 .then(movie=>{
			 	movieContent(movielist, movie)
			 })
	 	})
	}
})